<div>
    <ng-content></ng-content>
</div>
<div class="overlay" (click)="clickOverlay()"></div>